mapboxgl.accessToken = 'pk.eyJ1Ijoib2xzZW5ldXJvcGUiLCJhIjoiY2xjamRncHB3MDY5cDN2cW9rYjNjNTM2ZiJ9.VGL4lPNqnuzFv_zJ9RSgqg';

/**
 * Add the map to the page
 */

const config = {
 CSV: 'https://cdn.shopify.com/s/files/1/0260/1641/5819/files/Sample_Data.csv?v=1673985048',
  filters: [
    {
      type: 'dropdown',
      title: 'Languages supported: ',
      columnHeader: 'Languages',
      listItems: [
        'English',
        'French',
        'German',
        'Greek',
        'Hindi',
        'Italian',
        'Japanese',
        'Korean',
        'Language Line Services',
        'Norwegian',
        'Oriya',
        'Portuguese',
        'Punjabi',
        'Russian',
        'Somali',
        'Spanish',
        'Swedish',
        'Tagalog',
        'Thai',
        'Tigrinya',
        'Tongan',
        'Vietnamese',
        'Ukranian',
      ],
    },
    {
      type: 'checkbox',
      title: 'Devices available: ',
      columnHeader: 'Devices_available', // Case sensitive - must match spreadsheet entry
      listItems: ['Computer', 'Wi-Fi', 'Adaptive Laptops'], // Case sensitive - must match spreadsheet entry; This will take up to six inputs but is best used with a maximum of three;
    },
    {
      type: 'dropdown',
      title: 'Clients: ',
      columnHeader: 'Clients',
      listItems: [
        'Adults',
        'Disabled',
        'Homeless',
        'Immigrants/Refugees',
        'Low Income',
        'Seniors',
        'Youth: Pre-teen',
        'Youth: Teen',
      ],
    },
  ],
};
  
const map = new mapboxgl.Map({
  container: 'map',
  style: 'mapbox://styles/mapbox/light-v11',
  center: [-79.5924498,43.6184516],
  zoom: 8,
  scrollZoom: true
});

const stores = {
  'type': 'FeatureCollection',
  'features': [
        {
'type': 'Feature',
'geometry': {
'type': 'Point',
"coordinates": [
-73.8323681,45.4641575
]},
'properties': {
"phoneFormatted": "(514) 428-1710",
"name": "Fairview Pointe Claire",
"phone": "(514) 428-1710",
"address": "6801 Trans-Canada Hwy",
"city": "Pointe-Claire",
"state": "QC",
"postalCode": "H9R 4Y8",
"country": "Canada"
}},
    {
'type': 'Feature',
'geometry': {
'type': 'Point',
"coordinates": [
-73.6480484,45.5281296
]},
'properties': {
"phoneFormatted": "(514) 350-9523",
"name": "Rockland Centre",
"phone": "(514) 350-9523",
"address": "2305 Rockland Rd",
"city": "Montreal",
"state": "QC",
"postalCode": "H3P 3E9",
"country": "Canada"
}},
{
'type': 'Feature',
'geometry': {
'type': 'Point',
"coordinates": [
-79.6895596,43.4618365
]},
'properties': {
"phoneFormatted": "(905) 337‑5862",
"name": "Oakville Place",
"phone": "(905) 337‑5862",
"address": "240 Leighland Ave, Unit 241",
"city": "Oakville",
"state": "ON",
"postalCode": "L6H 3H6",
"country": "Canada"
}},
{
'type': 'Feature',
'geometry': {
'type': 'Point',
"coordinates": [
-79.5578605,43.6304852
]},
'properties': {
"phoneFormatted": "(416) 231-5551",
"name": "Cloverdale Mall (Outlet)",
"phone": "(416) 231-5551",
"address": "250 The East Mall",
"city": "Etobicoke",
"state": "Ontario",
"postalCode": "M9B 3Y8",
"country": "Canada"
}},
{
'type': 'Feature',
'geometry': {
'type': 'Point',
"coordinates": [
-122.7884665,49.0470089
]},
'properties': {
"phoneFormatted": "(604) 538-2466",
"name": "The Shops at Morgan Crossing",
"phone": "(604) 538-2466",
"address": "15715 Croydon Drive, Unit AB 108",
"city": "Surrey",
"state": "British Columbia",
"postalCode": "V3S 2L5",
"country": "Canada"
}},
{
'type': 'Feature',
'geometry': {
'type': 'Point',
"coordinates": [
-79.7924969,43.3510158
]},
'properties': {
"phoneFormatted": "(905) 319-2820",
"name": "Burlington Centre",
"phone": "(905) 319-2820",
"address": "777 Guelph Line",
"city": "Burlington",
"state": "Ontario",
"postalCode": "L7R 3N2",
"country": "Canada"
}},
{
'type': 'Feature',
'geometry': {
'type': 'Point',
"coordinates": [
-78.88099,
43.891998
]},
'properties': {
"phoneFormatted": "(250) 920-7902",
"name": "Mayfair Shopping Centre",
"phone": "(250) 920-7902",
"address": "3147 Douglas Street Unit 359",
"city": "Victoria",
"state": "British Columbia",
"postalCode": "V8Z 6E3",
"country": "Canada"
}},
{
'type': 'Feature',
'geometry': {
'type': 'Point',
"coordinates": [
-79.3858314,43.7678107
]},
'properties': {
"phoneFormatted": "(416) 229-6474",
"name": "Bayview Village",
"phone": "(416) 229-6474",
"address": "2901 Bayview Avenue, Unit 39",
"city": "Toronto",
"state": "Ontario",
"postalCode": "M2K 1E6",
"country": "Canada"
}},
{
'type': 'Feature',
'geometry': {
'type': 'Point',
"coordinates": [
-123.135832,
49.327522
]},
'properties': {
"phoneFormatted": "(604) 922-2029",
"name": "Park Royal Shopping Centre",
"phone": "(604) 922-2029",
"address": "Unit # 964A, Park Royal S.C (south)",
"city": "West Vancouver",
"state": "British Columbia",
"postalCode": "V7T 1A1",
"country": "Canada"
}},
{
'type': 'Feature',
'geometry': {
'type': 'Point',
"coordinates": [
-71.279835,
46.77213
]},
'properties': {
"phoneFormatted": "(418) 780-3038",
"name": "Place Ste-Foy",
"phone": "(418) 780-3038",
"address": "2450 Blvd Laurier, Unit #127A",
"city": "Quebec",
"state": "Quebec",
"postalCode": "G1V 2L1",
"country": "Canada"
}},
{
'type': 'Feature',
'geometry': {
'type': 'Point',
"coordinates": [
-63.5811226,44.6429513
]},
'properties': {
"phoneFormatted": "(902) 423-0516",
"name": "Park Lane Mall",
"phone": "(902) 423-0516",
"address": "5657 Spring Garden Road, Box 183",
"city": "Halifax",
"state": "Nova Scotia",
"postalCode": "B3J 3R4",
"country": "Canada"
}},
{
'type': 'Feature',
'geometry': {
'type': 'Point',
"coordinates": [
-81.277929,
43.026148
]},
'properties': {
"phoneFormatted": "(519) 667-0096",
"name": "Masonville Place",
"phone": "(519) 667-0096",
"address": "1680 Richmond St. N Unit U069",
"city": "London",
"state": "Ontario",
"postalCode": "N6G 3Y9",
"country": "Canada"
}},
{
'type': 'Feature',
'geometry': {
'type': 'Point',
"coordinates": [
-79.345007,
43.735518
]},
'properties': {
"phoneFormatted": "(416) 384-0876",
"name": "Shops at Don Mills",
"phone": "(416) 384-0876",
"address": "24 Karl Fraser Rd,  Unit J006B",
"city": "Toronto",
"state": "Ontario",
"postalCode": "M3C 0G5",
"country": "Canada"
}},
{
'type': 'Feature',
'geometry': {
'type': 'Point',
"coordinates": [
-79.452459,
43.80648
]},
'properties': {
"phoneFormatted": "(905) 882-0121",
"name": "Promenade",
"phone": "(905) 882-0121",
"address": "1 Promenade Circle, Unit #B208",
"city": "Thornhill",
"state": "Ontario",
"postalCode": "L4J 4P8",
"country": "Canada"
}},
{
'type': 'Feature',
'geometry': {
'type': 'Point',
"coordinates": [
-113.515496,
53.48615
]},
'properties': {
"phoneFormatted": "(780) 439-9399",
"name": "Southgate Centre",
"phone": "(780) 439-9399",
"address": "#51 - 5015 - 111 St. NW",
"city": "Edmonton",
"state": "Alberta",
"postalCode": "T6H 4M6",
"country": "Canada"
}},
{
'type': 'Feature',
'geometry': {
'type': 'Point',
"coordinates": [
-52.7568858,47.5610105
]},
'properties': {
"phoneFormatted": "(709) 722-7748",
"name": "Avalon Mall",
"phone": "(709) 722-7748",
"address": "48 Kenmount Road, unit 2030",
"city": "St. John's",
"state": "Newfoundland",
"postalCode": "A1B 1W3",
"country": "Canada"
}
},
    {
'type': 'Feature',
'geometry': {
'type': 'Point',
"coordinates": [
-78.9804466,43.0989433
]},
'properties': {
"phoneFormatted": " ",
"name": "Niagara Outlet",
"phone": "",
"address": "1900 Military Road",
"city": "Niagara Falls",
"state": "NY",
"postalCode": "14304",
"country": "US"
}}
  ]
};

/**
 * Assign a unique id to each store. You'll use this `id`
 * later to associate each point on the map with a listing
 * in the sidebar.
 */
stores.features.forEach((store, i) => {
  store.properties.id = i;
});

/**
 * Wait until the map loads to make changes to the map.
 */
map.on('load', () => {
  /**
   * This is where your '.addLayer()' used to be, instead
   * add only the source without styling a layer
   */
  map.addSource('places', {
    'type': 'geojson',
    'data': stores
  });

  /**
   * Create a new MapboxGeocoder instance.
   */
  const geocoder = new MapboxGeocoder({
    accessToken: mapboxgl.accessToken,
    mapboxgl: mapboxgl,
    marker: true,
    bbox: [-140.99778, 41.6751050889, -52.6480987209, 83.23324]
  });

  /**
   * Add all the things to the page:
   * - The location listings on the side of the page
   * - The search box (MapboxGeocoder) onto the map
   * - The markers onto the map
   */
  buildLocationList(stores);
  map.addControl(geocoder, 'top-left');
  addMarkers();

  /**
   * Listen for when a geocoder result is returned. When one is returned:
   * - Calculate distances
   * - Sort stores by distance
   * - Rebuild the listings
   * - Adjust the map camera
   * - Open a popup for the closest store
   * - Highlight the listing for the closest store.
   */
  geocoder.on('result', (event) => {
    /* Get the coordinate of the search result */
    const searchResult = event.result.geometry;

    /**
     * Calculate distances:
     * For each store, use turf.disance to calculate the distance
     * in miles between the searchResult and the store. Assign the
     * calculated value to a property called `distance`.
     */
    const options = { units: 'miles' };
    for (const store of stores.features) {
      store.properties.distance = turf.distance(
        searchResult,
        store.geometry,
        options
      );
    }

    /**
     * Sort stores by distance from closest to the `searchResult`
     * to furthest.
     */
    stores.features.sort((a, b) => {
      if (a.properties.distance > b.properties.distance) {
        return 1;
      }
      if (a.properties.distance < b.properties.distance) {
        return -1;
      }
      return 0; // a must be equal to b
    });

    /**
     * Rebuild the listings:
     * Remove the existing listings and build the location
     * list again using the newly sorted stores.
     */
    const listings = document.getElementById('listings');
    while (listings.firstChild) {
      listings.removeChild(listings.firstChild);
    }
    buildLocationList(stores);

    /* Open a popup for the closest store. */
    createPopUp(stores.features[0]);

    /** Highlight the listing for the closest store. */
    const activeListing = document.getElementById(
      `listing-${stores.features[0].properties.id}`
    );
    activeListing.classList.add('active');

    /**
     * Adjust the map camera:
     * Get a bbox that contains both the geocoder result and
     * the closest store. Fit the bounds to that bbox.
     */
    const bbox = getBbox(stores, 0, searchResult);
    map.fitBounds(bbox, {
      padding: 100
    });
  });
});

/**
 * Using the coordinates (lng, lat) for
 * (1) the search result and
 * (2) the closest store
 * construct a bbox that will contain both points
 */
function getBbox(sortedStores, storeIdentifier, searchResult) {
  const lats = [
    sortedStores.features[storeIdentifier].geometry.coordinates[1],
    searchResult.coordinates[1]
  ];
  const lons = [
    sortedStores.features[storeIdentifier].geometry.coordinates[0],
    searchResult.coordinates[0]
  ];
  const sortedLons = lons.sort((a, b) => {
    if (a > b) {
      return 1;
    }
    if (a.distance < b.distance) {
      return -1;
    }
    return 0;
  });
  const sortedLats = lats.sort((a, b) => {
    if (a > b) {
      return 1;
    }
    if (a.distance < b.distance) {
      return -1;
    }
    return 0;
  });
  return [
    [sortedLons[0], sortedLats[0]],
    [sortedLons[1], sortedLats[1]]
  ];
}

/**
 * Add a marker to the map for every store listing.
 **/
function addMarkers() {
  /* For each feature in the GeoJSON object above: */
  for (const marker of stores.features) {
    /* Create a div element for the marker. */
    const el = document.createElement('div');
    /* Assign a unique `id` to the marker. */
    el.id = `marker-${marker.properties.id}`;
    /* Assign the `marker` class to each marker for styling. */
    el.className = 'marker';

    /**
     * Create a marker using the div element
     * defined above and add it to the map.
     **/
    new mapboxgl.Marker(el, { offset: [0, -23] })
      .setLngLat(marker.geometry.coordinates)
      .addTo(map);

    /**
     * Listen to the element and when it is clicked, do three things:
     * 1. Fly to the point
     * 2. Close all other popups and display popup for clicked store
     * 3. Highlight listing in sidebar (and remove highlight for all other listings)
     **/
    el.addEventListener('click', (e) => {
      flyToStore(marker);
      createPopUp(marker);
      const activeItem = document.getElementsByClassName('active');
      e.stopPropagation();
      if (activeItem[0]) {
        activeItem[0].classList.remove('active');
      }
      const listing = document.getElementById(
        `listing-${marker.properties.id}`
      );
      listing.classList.add('active');
    });
  }
}

/**
 * Add a listing for each store to the sidebar.
 **/
function buildLocationList(stores) {
  for (const store of stores.features) {
    /* Add a new listing section to the sidebar. */
    const listings = document.getElementById('listings');
    const listing = listings.appendChild(document.createElement('div'));
    /* Assign a unique `id` to the listing. */
    listing.id = `listing-${store.properties.id}`;
    /* Assign the `item` class to each listing for styling. */
    listing.className = 'item';

    /* Add the link to the individual listing created above. */
    const link = listing.appendChild(document.createElement('a'));
    link.href = '#';
    link.className = 'title';
    link.id = `link-${store.properties.id}`;
    link.innerHTML = `${store.properties.name}`;

    /* Add details to the individual listing. */
    const details = listing.appendChild(document.createElement('div'));
    details.innerHTML = `${store.properties.address}<br/> ${store.properties.city}, ${store.properties.state} ${store.properties.postalCode}<br/>`;
    if (store.properties.phone) {
      details.innerHTML += `<strong>Phone:</strong> <a href="tel:+1${store.properties.phoneFormatted}">${store.properties.phoneFormatted}</a>`;
    }
    if (store.properties.distance) {
      const roundedDistance =
        Math.round(store.properties.distance * 160) / 100;
      details.innerHTML += `<div><strong>${roundedDistance} km away</strong></div>`;
    }

    /**
     * Listen to the element and when it is clicked, do four things:
     * 1. Update the `currentFeature` to the store associated with the clicked link
     * 2. Fly to the point
     * 3. Close all other popups and display popup for clicked store
     * 4. Highlight listing in sidebar (and remove highlight for all other listings)
     **/
    link.addEventListener('click', function () {
      for (const feature of stores.features) {
        if (this.id === `link-${feature.properties.id}`) {
          flyToStore(feature);
          createPopUp(feature);
        }
      }
      const activeItem = document.getElementsByClassName('active');
      if (activeItem[0]) {
        activeItem[0].classList.remove('active');
      }
      this.parentNode.classList.add('active');
    });
  }
}

/**
 * Use Mapbox GL JS's `flyTo` to move the camera smoothly
 * a given center point.
 **/
function flyToStore(currentFeature) {
  map.flyTo({
    center: currentFeature.geometry.coordinates,
    zoom: 15
  });
}

/**
 * Create a Mapbox GL JS `Popup`.
 **/
function createPopUp(currentFeature) {
  const popUps = document.getElementsByClassName('mapboxgl-popup');
  if (popUps[0]) popUps[0].remove();

  const popup = new mapboxgl.Popup({ closeOnClick: false })
    .setLngLat(currentFeature.geometry.coordinates)
    .setHTML(
      `<h3>${currentFeature.properties.name}</h3><p>${currentFeature.properties.address}<br/>${currentFeature.properties.city},${currentFeature.properties.state} ${currentFeature.properties.postalCode}<br/><strong>Phone:</strong> ${currentFeature.properties.phone}</p>`
    )
    .addTo(map);
}

$(document).click(function() {
    var container = $(".mapboxgl-popup");
    if (!container.is(event.target) && !container.has(event.target).length) {
        container.hide();
    }
});